/* import __COLOCATED_TEMPLATE__ from './audience-preview-non-starting-node.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();